(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        document.dispatchEvent(new CustomEvent('headerSticky', { detail: { isSticky: true } }));
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.dispatchEvent(new CustomEvent('headerSticky', { detail: { isSticky: false } }));
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      document.dispatchEvent(new CustomEvent('headerSticky', { detail: { isSticky: true } }));
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      document.dispatchEvent(new CustomEvent('headerSticky', { detail: { isSticky: false } }));
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations-cart"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };
      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('timeline-slider')) {
    class TimelineSlider extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.yearButtons = Array.from(this.querySelectorAll('[data-goto]'));
        this.btnPrev = this.querySelector('[data-prev]');
        this.btnNext = this.querySelector('[data-next]');
        this.viewport = this.querySelector('[data-viewport]');
        this.index = 0;
        this.locked = false;
        this.wheelActive = false;
        this.wheelTimer = null;
        this.useWheel = this.dataset.wheel !== 'false';

        this.yearButtons.forEach((b) =>
          b.addEventListener('click', () => this.go(Number(b.dataset.goto)))
        );
        this.btnPrev.addEventListener('click', () => this.go(this.index - 1));
        this.btnNext.addEventListener('click', () => this.go(this.index + 1));

        this.addEventListener('keydown', (e) => this.onKey(e));
        if (this.useWheel) {
          this.addEventListener('wheel', (e) => this.onWheel(e), { passive: false });
        }

        // touch (vertical swipe)
        let sx = 0, sy = 0, dx = 0, dy = 0;
        this.viewport.addEventListener('touchstart', (e) => {
          sx = e.touches[0].clientX;
          sy = e.touches[0].clientY;
          dx = dy = 0;
        }, { passive: true });
        this.viewport.addEventListener('touchmove', (e) => {
          dx = e.touches[0].clientX - sx;
          dy = e.touches[0].clientY - sy;
          if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 10) {
            const target = this.index + (dy < 0 ? 1 : -1);
            if (target >= 0 && target < this.slides.length) e.preventDefault();
          }
        }, { passive: false });
        this.viewport.addEventListener('touchend', () => {
          if (Math.abs(dy) > 40 && Math.abs(dy) > Math.abs(dx)) {
            this.go(this.index + (dy < 0 ? 1 : -1));
          }
        });

        // Theme editor: jump to the block being edited
        this.addEventListener('shopify:block:select', (e) => {
          const slide = e.target.closest('[data-slide]');
          if (slide) this.go(Number(slide.dataset.index));
        });

        // Keep the stage tall enough for the longest slide
        this._lastWidth = 0;
        if ('ResizeObserver' in window) {
          this._ro = new ResizeObserver(() => {
            const w = this.viewport.offsetWidth;
            if (w !== this._lastWidth) {
              this._lastWidth = w;
              this.fit();
            }
          });
          this._ro.observe(this.viewport);
        }
        this.fit();
        this.go(0);
      }

      disconnectedCallback() {
        if (this._ro) this._ro.disconnect();
      }

      fit() {
        let h = 0;
        this.querySelectorAll('.tl__slide-inner').forEach((el) => {
          h = Math.max(h, el.offsetHeight);
        });
        this.style.setProperty('--tl-fit', h ? h + 16 + 'px' : '0px');
      }

      go(i) {
        const max = this.slides.length - 1;
        i = Math.max(0, Math.min(max, i));
        this.index = i;
        this.style.setProperty('--tl-index', i);

        this.slides.forEach((s, n) => {
          const active = n === i;
          s.classList.toggle('is-active', active);
          if (active) {
            s.removeAttribute('inert');
            s.removeAttribute('aria-hidden');
          } else {
            s.setAttribute('inert', '');
            s.setAttribute('aria-hidden', 'true');
          }
        });
        this.yearButtons.forEach((b, n) => {
          if (n === i) b.setAttribute('aria-current', 'true');
          else b.removeAttribute('aria-current');
        });
        this.btnPrev.disabled = i === 0;
        this.btnNext.disabled = i === max;
      }

      onKey(e) {
        const map = { ArrowDown: 1, ArrowUp: -1, PageDown: 1, PageUp: -1 };
        if (e.key in map) {
          e.preventDefault();
          this.go(this.index + map[e.key]);
        } else if (e.key === 'Home') {
          e.preventDefault();
          this.go(0);
        } else if (e.key === 'End') {
          e.preventDefault();
          this.go(this.slides.length - 1);
        }
      }

      onWheel(e) {
        if (Math.abs(e.deltaY) < Math.abs(e.deltaX)) return;
        const dir = e.deltaY > 0 ? 1 : -1;
        const target = this.index + dir;

        // at the first/last slide: let the page scroll normally
        if (target < 0 || target >= this.slides.length) return;

        e.preventDefault();

        // one wheel gesture = one step (ignores trackpad inertia)
        clearTimeout(this.wheelTimer);
        this.wheelTimer = setTimeout(() => (this.wheelActive = false), 150);
        if (this.wheelActive || this.locked || Math.abs(e.deltaY) < 4) return;

        this.wheelActive = true;
        this.locked = true;
        setTimeout(() => (this.locked = false), 600);
        this.go(target);
      }
    }
    customElements.define('timeline-slider', TimelineSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
